export interface BuildWorkosAuthorizeUrlOptions {
  /** WorkOS Client ID, e.g. `client_01...`. */
  clientId: string;
  /** Where WorkOS should redirect with the auth `?code=...`. */
  redirectUri: string;
  /** Base64URL(SHA-256(verifier)) — the public half of the PKCE pair. */
  codeChallenge: string;
  /** Optional opaque value echoed back in the redirect (CSRF defense). */
  state?: string;
  /** Optional WorkOS provider hint, e.g. `'GoogleOAuth'` to skip the connection picker. */
  provider?: string;
  /** Optional AuthKit screen hint, e.g. `'sign-in'` or `'sign-up'`. */
  screenHint?: 'sign-in' | 'sign-up';
}

const AUTHORIZE_URL = 'https://api.workos.com/user_management/authorize';

export const buildWorkosAuthorizeUrl = (options: BuildWorkosAuthorizeUrlOptions): string => {
  const params = new URLSearchParams({
    client_id: options.clientId,
    redirect_uri: options.redirectUri,
    response_type: 'code',
    code_challenge: options.codeChallenge,
    code_challenge_method: 'S256',
  });

  if (options.state) params.set('state', options.state);
  if (options.provider) params.set('provider', options.provider);
  else params.set('provider', 'authkit');
  if (options.screenHint) params.set('screen_hint', options.screenHint);

  return `${AUTHORIZE_URL}?${params.toString()}`;
};
